/**
 * Пиццерия с адресом для извлечения городов фильтра.
 */
interface PizzeriaWithCity {
  address?: {
    city?: string | null
  } | null
}

/**
 * Возвращает уникальные города из списка пиццерий, отсортированные по алфавиту.
 * @param pizzerias — список пиццерий из Redux
 * @returns массив названий городов
 */
const getUniqueCitiesFromPizzerias = (
  pizzerias?: PizzeriaWithCity[] | null
): string[] => {
  if (!Array.isArray(pizzerias)) {
    return []
  }

  const citySet = new Set<string>()

  pizzerias.forEach(pizzeriaItem => {
    const cityName = pizzeriaItem?.address?.city?.trim?.()
    if (cityName) {
      citySet.add(cityName)
    }
  })

  return Array.from(citySet).sort((leftCity, rightCity) =>
    leftCity.localeCompare(rightCity, 'ru')
  )
}

export default getUniqueCitiesFromPizzerias
